import React, { PureComponent } from "react";
import { injectIntl, FormattedHTMLMessage } from "react-intl";
import classnames from "classnames";

import { CardIcon, IdentificationIcon, CalendarIcon } from "./Icons";

import "./Product.css";

export default injectIntl(
  class Level extends PureComponent {
    touched = (code, availability) => e => {
      if (availability === 0) {
        const { onChanged } = this.props;
        onChanged(code);
      }
    };

    renderRanges = ranges => {
      if (ranges !== undefined) {
        return ranges.map((r, index) => (
          <div key={`date-${index}`} className="cm-product--detail">
            <CalendarIcon className="cm-product--icons" />
            {r.date}
          </div>
        ));
      }
    };

    renderSchedule = schedule => {
      if (schedule !== undefined) {
        return (
          <div>
            <div className="cm-product--detail">
              <IdentificationIcon className="cm-product--icons" />
              <FormattedHTMLMessage
                id="schedule"
                values={{ days: schedule.days, start: schedule.start }}
              />
            </div>
            {this.renderRanges(schedule.ranges)}
          </div>
        );
      }
    };

    renderItem = item => {
      if (item.schedule !== undefined) {
        return (
          <div className="cm-product--item">
            {this.renderSchedule(item.schedule)}
          </div>
        );
      }
    };

    renderStructure = structure => {
      return (
        <div className="cm-product--structure-outer">
          {structure.map(item => (
            <div className="cm-product--structure" key={item.code}>
              <div className="cm-product--item-name">{item.name}</div>
              {this.renderItem(item)}
            </div>
          ))}
        </div>
      );
    };

    renderErrorMessage = availability => {
      const { intl } = this.props;
      if (availability > 1) {
        return (
          <div className="cm-product-error">
            {intl.messages[`unavailable${availability}`]}
          </div>
        );
      }
    };

    render() {
      const { product, selected } = this.props;
      const { code, name, structure, availability } = product;
      const outerClasses = classnames("cm-product--outer", {
        "cm-product--outer__selected": selected,
        "cm-product--outer__disabled": availability > 1
      });

      return (
        <div
          className={outerClasses}
          onClick={this.touched(code, availability)}
        >
          <div className="cm-product--marker" />
          <div className="cm-product--main">
            {this.renderErrorMessage(availability)}
            <div className="cm-product--desc">
              <div className="cm-product--title">
                <CardIcon className="cm-product--icon" />
                {name}
              </div>
              {structure !== undefined
                ? this.renderStructure(structure)
                : this.renderItem(product)}
            </div>
          </div>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Product.js